import { TaskState } from "../task/model";

import { TaskAction } from "./actions";
import * as actions from "./actiontypes";

export function taskReducer(state: TaskState = { taskTypes: [] }, action: TaskAction): TaskState {
    switch (action.type) {
        case actions.LOAD_TASK_TYPES_SUCCESS:
            return { taskTypes: action.payload };
        default:
            return state;
    }
}
